import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import _ from "lodash";
import { Rows } from "./rows";
import { empty, invalid } from "@codeArt/utils/common";
import { memo } from "@codeArt/components/common";

const List = ({
  width,
  columns,
  onRowSelect,
  separator,
  rowHover,
  go,
  rows,
  radioName,
  checkbox,
  radio,
  handleRowClick,
  handleKeyDown,
  handleTargetClick,
  selected,
  getRowDisabled,
  getRowKey,
  isSelected
}) => {
  let noLine =
    !empty(separator) && (separator === false || separator.pc === false);

  let style = {};
  if (!invalid(width)) {
    style = { width, minWidth: "100%" };
  }

  return (
    <div className="d-flex flex-column" style={style}>
      <Table>
        <TableBody>
          <Rows
            columns={columns}
            onRowSelect={onRowSelect}
            separator={separator}
            hover={rowHover}
            go={go}
            rows={rows}
            radioName={radioName}
            checkbox={checkbox}
            radio={radio}
            noLine={noLine}
            handleRowClick={handleRowClick}
            handleKeyDown={handleKeyDown}
            handleTargetClick={handleTargetClick}
            getRowDisabled={row=>{
              if(!getRowDisabled) return false;
              return getRowDisabled(row);
            }}
            getRowKey={row => {
              return getRowKey(row);
            }}
            isSelected={isSelected}
            fixed={Boolean(width)}
          />
        </TableBody>
      </Table>
    </div>
  );
};

export { List };
